module.exports = __webpack_public_path__ + "fonts/bceda3f.otf";